(function () {
  'use strict';

  angular.module('app').service('BankModalService', BankModalService);

  BankModalService.$inject = ['ModalService'];

  function BankModalService(ModalService) {
    var service = {
      openBanks: openBanks,
    };

    return service;

    function openBanks(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/banks/modals/bank-list-modal.html',
        controller: BankListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });

      BankListModalCtrl.$inject = [
        'BankService',
        'LanguageService',
        'AbilityService',
        'UtilService',
      ];
    }

    function BankListModalCtrl(BankService, LanguageService, AbilityService, UtilService) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_bank_accountadmin'),
        canCreate: AbilityService.can('create_bank_accountadmin'),
      };

      // Methods
      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      // vm.onDeletedItem  = onDeletedItem;

      // Initializers
      // getItems();
      getAdditionalLanguages();

      function getItems(selectedItem) {
        vm.modalTitle = 'BANKS';

        if (!vm.permissions.canList) {
          return;
        }

        vm.filterCriteria = BankService.getFilterCriteria();
        vm.filterCriteria.lang = vm.defaultLanguage;

        vm.loadingItems = true;
        BankService.getBanks(vm.filterCriteria).then(function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }

          vm.loadingItems = false;
        });
      }

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
          let languages = data.items;

          vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
          vm.additionalLanguages = languages.filter((language) => !language.is_default);

          getItems('');
        });
      }

      function getItem(item) {
        vm.item = null;

        vm.loadingItem = true;
        BankService.getBank(item.id, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_BANK';
      }

      function onSavedItem() {
        // item
        cancel(); // item
      }

      function cancel() {
        vm.createMode = false;
        vm.editMode = false;

        getItems('');
      }

      function onCanceledItem() {
        cancel();
      }

      function onShowItem(item, mode) {
        vm.editMode = true;
        vm.modalTitle = 'BANK_DETAILS';

        vm.mode = mode;

        getItem(item);
      }

      // function onDeletedItem() {
      //     cancel();
      // }
    }
  }
})();
